import * as userAction from "../actions/linkingModules.action";
const linkingModules = (
  state = {
    status: null,
    loading: false,
    error: null,
    linkingModulesData: null,
  },
  action,
) => {
  switch (action.type) {
    case userAction.LINKINGMODULES_REQUEST:
      return Object.assign({}, state, {
        status: action.status,
        loading: true,
      });
    case userAction.LINKINGMODULES_SUCCESS:
      return Object.assign({}, state, {
        linkingModulesData: action?.linkingModulesData,
        status: action.status,
        loading: false,
      });
    case userAction.LINKINGMODULES_FAILURE:
      return Object.assign({}, state, {
        error: action.error,
      });
    default:
      return state;
  }
};
export default linkingModules;
